import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';

import InputGridFormFieldsModal from '../modal/input_grid_form_fields_modal.js';

import InputGroup from 'form/components/form/input_group.jsx';

import { Button } from 'realize/components/button';
import { ModalActions } from "realize/stores/modal_store";

import ScreenSizes from 'screen_sizes';

import { FormAPI } from 'lecom-api';

@mixin.decorate(window.CssClassMixin)
export default class InputGridFormFields extends React.Component {
	static propTypes = {
		formId: PropTypes.number,
		id: PropTypes.string,
		inputs: PropTypes.object,
		data: PropTypes.object,
		style: PropTypes.string,
		resource: PropTypes.string,
		disabled: PropTypes.bool,
		isLoading: PropTypes.bool,
		readOnly: PropTypes.bool,
		submitButton: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
		otherButtons: PropTypes.array,
		formAction: PropTypes.string,
		onSubmit: PropTypes.func,
		onReset: PropTypes.func
	};

	static defaultProps = {
		themeClassKey: 'form',
		id: null,
		inputs: {},
		data: {},
		style: 'default',
		resource: null,
		disabled: false,
		isLoading: false,
		readOnly: false,
		submitButton: {
			name: 'actions.send',
			icon: 'send'
		},
		otherButtons: [],
		onSubmit: () => {},
		onReset: () => {}
	};

	constructor(props) {
		super(props);

		this.handleSubmitButtonClick = this.handleSubmitButtonClick.bind(this);
		this.submitFormFields = this.submitFormFields.bind(this);
		this.submitModalFormFields = this.submitModalFormFields.bind(this);
		this.resetModalFormFields = this.resetModalFormFields.bind(this);
	}

	handleSubmitButtonClick(event) {
		(window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH)
		? this.submitFormFields(event)
		: this.openFormFieldsModal(event);
	}

	getFieldAPI() {
		var form = FormAPI.form(this.props.formId);
		return form.fields(this.props.id);
	}

	submitFormFields(event) {
		var fieldsGrid = this.getFieldAPI().fields();
		for (let cont = 0, len = fieldsGrid.length; cont < len; cont++) {
			let value = fieldsGrid[cont].value();
			if (!value && value != null) {
				fieldsGrid[cont].value(null);
			}
		}

		FormAPI.form(this.props.formId).apply().then(() => {
			const inputGroupRef = this.refs.inputGroup;
			const fieldsData = inputGroupRef.serialize();

			this.props.onSubmit(event, fieldsData);
		})
	}

	openFormFieldsModal(event) {
		let modalId = this.props.id + "-modal";
		ModalActions.open({ modalId: modalId });
	}

	submitModalFormFields(event, fieldsData) {
		this.props.onSubmit(event, fieldsData);
	}

	resetModalFormFields(event) {
		this.props.onReset(event);
	}

	reset() {
		this.props.onReset();
	}

	renderInputs() {
		if (!this.props.inputs) {
			return [];
		}

		return (
			<InputGroup
				{...this.propsWithoutCSS()}
				label={null}
				errors={this.props.errors}
				formStyle={this.props.style}
				ref="inputGroup" />
		);
	}

	renderInputsInModal() {
		if (!this.props.inputs) {
			return [];
		}

		return (
			<InputGridFormFieldsModal
				{...this.propsWithoutCSS()}
				errors={this.props.errors}
				formStyle={this.props.style}
				onFormReset={this.resetModalFormFields}
				onFormSubmit={this.submitModalFormFields}
				ref="inputsModal"
			/>
		);
	}

	renderButtons() {
		return (
			<div className={this.themedClassName('form.buttonGroup')}>
			{this.renderOtherButtons()}
			{this.renderSubmitButton()}
			</div>
		);
	}

	renderOtherButtons() {
		const otherButtonsProps = this.props.otherButtons;
		const otherButtons = [];

		for (let i = 0; i < otherButtonsProps.length; i++) {
			const otherButtonProps = otherButtonsProps[i];
			if(otherButtonProps.hidden) continue;

			otherButtons.push(
				<Button
				{...otherButtonProps}
				element="a"
				role='button'
				disabled={otherButtonProps.disabled || this.props.isLoading}
				key={otherButtonProps.name}
				/>
			);
		}

		return otherButtons;
	}

	renderSubmitButton() {
		const { submitButton } = this.props;
		if (!submitButton || submitButton.hidden) {
			return [];
		}

		return (
			<Button
			{...submitButton}
			element="a"
			role='button'
			disabled={submitButton.disabled || this.props.isLoading}
			onClick={this.handleSubmitButtonClick}
			/>
		);
	}

	render() {
		return (
			<div id={this.props.id} className={this.className()} ref="form">
			{(window.innerWidth > ScreenSizes.SMALL_SCREEN_WIDTH) ? this.renderInputs() : this.renderInputsInModal()}
			{this.renderButtons()}
			</div>
		);
	}
}